// src/contexts/produtos/BarraContext.js
// contexts/produtos/BarraContext.js
import React, { createContext, useContext, useRef, useState } from 'react';
import { postData, putData, deleteData } from '../../services/Api';
import { buscarBarrasPorProduto } from '../../services/produtos/BarraService';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';

const BarraContext = createContext();

export const useBarra = () => useContext(BarraContext);

export const BarraProvider = ({ children }) => {
    const [barras, setBarras] = useState([]);
    const consultaRef = useRef({ produtoId: 0 });
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const fetchbarras = async (produtoId) => {
        const consulta = { produtoId: Number(produtoId) || 0 };
        consultaRef.current = consulta;
        setBarras([]);
        if (!consulta.produtoId) return;

        try {
            const result = await buscarBarrasPorProduto(produtoId);
            if (consultaRef.current === consulta) setBarras(result || []);
        } catch (error) {
            if (consultaRef.current !== consulta) return;
            console.error("Erro ao buscar barras:", error);
            showMessage('Erro ao buscar barras!\n' + error, 'danger');
        }
    }
    

    // useEffect(() => {
    //     const fetchDataFromAPI = async () => {
    //         try {
    //             const result = await fetchData('/Barra');
    //             setBarras(result);
    //         } catch (error) {
    //             console.error("Erro ao buscar barras:", error);
    //             showMessage('Erro ao buscar barras!\n' + error, 'danger');
    //         }
    //     };
    //     fetchDataFromAPI();
    // }, []);

    const addBarra = async (barra) => {
        try {
            const result = await postData('/Barra', barra);
            if (consultaRef.current.produtoId === Number(barra.produtoId)) {
                setBarras(atuais => [...atuais, result]);
            }
            showAlert('Código de barras adicionado com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar barra:", error);
            showMessage('Erro ao adicionar código de barras!\n' + error, 'danger');
        }
    };

    const updateBarra = async (barra) => {
        try {
            const result = await putData('/Barra', barra);
            setBarras(atuais => atuais.map(b => b.id === result.id ? result : b));
            showAlert('Código de barras atualizado com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar barra:", error);
            showMessage('Erro ao atualizar código de barras!\n' + error, 'danger');
        }
    };

    const deleteBarra = async (id) => {
        try {
            await deleteData('/Barra', { barraId: id });
            setBarras(atuais => atuais.filter(b => b.id !== id));
            showAlert('Código de barras excluído com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir barra:", error);
            showMessage('Erro ao excluir código de barras!\n' + error, 'danger');
        }
    };

    return (
        <BarraContext.Provider value={{ barras, fetchbarras, addBarra, updateBarra, deleteBarra }}>
            {children}
        </BarraContext.Provider>
    );
};
